* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  height: auto;
  margin-top: 20px;
}
